// extracted by mini-css-extract-plugin
export default {"ourCoursesCarouselContainer":"OurCoursesCarousel_ourCoursesCarouselContainer__T8FBi"};